import * as React from "react";
import Screen from "../../components/screen/Screen";
import {ROUTE_CONTACT} from "../../routing/Routes";
import ContactMap from "./ContactMap";
import {AppIcon, ContactInfo} from "../../Config";
import Link from "../Link";
import {FormattedMessage} from "react-intl";

interface Props {

}

export default class ContactScreen extends React.Component<Props> {

    public render(): React.ReactNode {

        return (
            <Screen currentRoute={ROUTE_CONTACT}>
                <div className={"section-container contact"}>
                    <h2><FormattedMessage id={'contact-with-us'}/></h2>


                    <div className={"content"}>

                        <div className={"flex-container"}>
                            <div className={"flex-item"}>
                                <div className={"contact-item"}
                                     onClick={() => Link.onMailTo(ContactInfo.MAIL)}
                                >
                                    <div className={`${AppIcon.ENVELOP} icon-title`}/>
                                    <div className={"text"}>{ContactInfo.MAIL}</div>
                                </div>
                            </div>

                            <div className={"flex-item"}>
                                <div className={"contact-item"}
                                     onClick={() => Link.onWindowOpen(ContactInfo.FACEBOOK)}
                                >
                                    <div className={`${AppIcon.FACEBOOK} icon-title`}/>
                                    <div className={"text"}>Club Tir amb Arc Borriana</div>
                                </div>
                            </div>

                            <div className={"flex-item"}>
                                <div className={"contact-item"}
                                     onClick={() => Link.onPhoneTo(ContactInfo.PHONE)}
                                >
                                    <div className={`${AppIcon.PHONE} icon-title`}/>
                                    <div className={"text"}>{ContactInfo.PHONE}</div>
                                </div>
                            </div>
                        </div>

                        <div className={"contact-item"}>
                            <div className={`${AppIcon.ADDRESS} icon-title`}/>
                            <div className={"text"}>
                               <FormattedMessage id={'club-direction'}/>
                            </div>
                        </div>

                        <ContactMap/>
                    </div>
                </div>
            </Screen>
        )
    }
}